import { makeVar } from '@apollo/client';

export type AppLanguage = 'ru' | 'pl';

const SUPPORTED: AppLanguage[] = ['ru', 'pl'];
const STORAGE_KEY = 'appLanguage';

/** Resolves the boot language: localStorage → REACT_APP_LANG → 'ru'. */
export const getInitialLanguage = (): AppLanguage => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED.includes(stored as AppLanguage)) {
    return stored as AppLanguage;
  }
  const env = process.env.REACT_APP_LANG;
  return env && SUPPORTED.includes(env as AppLanguage)
    ? (env as AppLanguage)
    : 'ru';
};

/** Persists the chosen language so it survives a reload. */
export const persistLanguage = (lang: AppLanguage): void =>
  localStorage.setItem(STORAGE_KEY, lang);

/** Reactive source of truth for the active UI language. */
export const languageVar = makeVar<AppLanguage>(getInitialLanguage());
